module.exports = __webpack_public_path__ + "img/蓝背景.fb287db1.png";